import axios from "axios";
import config from '../environment/config';  // picks dev or prod automatically

// Backend URL configuration
const API_BASE = config.API_URL;           // Backend base URL from environment
const USER_API = `${API_BASE}api/seo-user`;  // Signup API
const AUTH_API = `${API_BASE}/authenticate`;  // Login API

// ------------------- LOGIN -------------------
export const login = async (dto) => {
  console.log('Login API URL:', AUTH_API); // Debug URL
  try {
    const response = await axios.post(AUTH_API, dto, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    // Save token
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }

    // Save user info including role
    if (response.data.username) {
      localStorage.setItem('username', response.data.username);
    }

    if (response.data.email) {
      localStorage.setItem('email', response.data.email);
    }

    if (response.data.role) {
      localStorage.setItem('role', response.data.role);  
    }

    return response.data;
  } catch (error) {
    console.error('Login failed:', error.response?.data || error.message);
    throw error;
  }

};
export const getToken = () => localStorage.getItem("token");

export const fetchProtectedData = async () => {
  
  const token = getToken();
  return axios.get(`${API_BASE}/protected-endpoint`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json'
    }
  });
};


// ------------------- SIGNUP -------------------
export const signup = async (formData) => {
  console.log('Signup API URL:', USER_API); // Debug URL
  try {
    const signupPayload = {
      actionType: "INSERT",
      name: formData.name,
      email: formData.email,
      password: formData.password,
      mobile: formData.mobile
    };

    const response = await axios.post(USER_API, signupPayload, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (err) {
    console.error("Signup API error:", err.response ? err.response.data : err);
    return null;
  }
};
